import { createRequest, getEndpoint } from "../requestCreator";

export const getWorkItems = createRequest(getEndpoint("workItems.sub.get"));
